import PropTypes from "prop-types";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Popover from "app/components/ui/Popover/Popover";
import SmartDPProductPricingItem from "app/pages/SmartDP/Listing/SmartDPProduct/SmartDPProductPricingInfo/SmartDPProductPricingItem";
import { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

import "./SmartDPProductPricingInfo.scss";

const SmartDPProductPricingInfo = ({ basePrice, upgradePrice = [], total }) => {
	if (upgradePrice.length === 0) {
		return false;
	}

	return (
		<Popover
			iconClassName="sdp-product__pricing-info-icon"
			dataTestId="sdp-product-pricing-info-icon"
		>
			<div className="sdp-product__pricing-info">
				<SmartDPProductPricingItem label={basePrice.label} amount={basePrice.amount} />

				{upgradePrice.map(item => (
					<SmartDPProductPricingItem
						key={item.label}
						label={
							<FormattedMessage id={`sdp.listing.product.price.info.${item.label}`} />
						}
						amount={item.amount}
						sign="+"
					/>
				))}

				<SmartDPProductPricingItem
					label={<FormattedMessage id="sdp.listing.product.price.info.TOTAL" />}
					amount={total}
					isBold
					fontSize={TYPOGRAPHY_VARIANTS.LARGE}
				/>
			</div>
		</Popover>
	);
};

SmartDPProductPricingInfo.propTypes = {
	basePrice: PropTypes.shape({
		label: PropTypes.string,
		amount: PropTypes.number,
	}).isRequired,
	upgradePrice: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			amount: PropTypes.number,
		})
	),
	total: PropTypes.number.isRequired,
};

export default memo(SmartDPProductPricingInfo);
